


import { Routes, RouterModule } from '@angular/router';
import { DetailFormComponent } from './detailform.component';

const routes: Routes = [
    {
        path: '',
        component: DetailFormComponent
    },
];

export const DetailFormRoutes = RouterModule.forChild(routes);
